// ─────────────────────────────────────────────────────────────
//  Shared Framer-Motion Variants & Helpers
// ─────────────────────────────────────────────────────────────

// Easing presets
export const EASE_OUT = [0.25, 0.1, 0.25, 1];
export const EASE_IN_OUT = [0.4, 0, 0.2, 1];
export const EASE_SPRING = { type: 'spring', stiffness: 80, damping: 20 };

// ─── Fade Variants ───────────────────────────────────────────
export const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1, y: 0,
    transition: { duration: 0.7, ease: EASE_OUT },
  },
};

export const fadeInDown = {
  hidden: { opacity: 0, y: -40 },
  visible: {
    opacity: 1, y: 0,
    transition: { duration: 0.7, ease: EASE_OUT },
  },
};

export const fadeInLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1, x: 0,
    transition: { duration: 0.7, ease: EASE_OUT },
  },
};

export const fadeInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: {
    opacity: 1, x: 0,
    transition: { duration: 0.7, ease: EASE_OUT },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.6, ease: EASE_OUT },
  },
};

// ─── Scale Variants ──────────────────────────────────────────
export const scaleIn = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: {
    opacity: 1, scale: 1,
    transition: { duration: 0.6, ease: EASE_OUT },
  },
};

export const scaleInSpring = {
  hidden: { opacity: 0, scale: 0.7 },
  visible: {
    opacity: 1, scale: 1,
    transition: EASE_SPRING,
  },
};

// ─── Container / Stagger Variants ────────────────────────────
export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

export const staggerContainerFast = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.05,
    },
  },
};

export const staggerContainerSlow = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.15,
    },
  },
};

// ─── Slide Variants ──────────────────────────────────────────
export const slideInFromBottom = {
  hidden: { opacity: 0, y: 60, scale: 0.97 },
  visible: {
    opacity: 1, y: 0, scale: 1,
    transition: { duration: 0.75, ease: EASE_OUT },
  },
};

// ─── Hover Variants ──────────────────────────────────────────
export const hoverLift = {
  rest: { y: 0, boxShadow: '0 4px 20px rgba(0,0,0,0.2)' },
  hover: {
    y: -8,
    boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
    transition: { duration: 0.3, ease: EASE_OUT },
  },
};

export const hoverScale = {
  rest: { scale: 1 },
  hover: { scale: 1.04, transition: { duration: 0.3, ease: EASE_OUT } },
};

// ─── Page Transition Variants ────────────────────────────────
export const pageVariants = {
  initial: { opacity: 0, y: 24 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -16 },
};

export const pageTransition = {
  type: 'tween',
  ease: EASE_OUT,
  duration: 0.45,
};

// ─── Viewport helper (pass as prop) ──────────────────────────
export const viewport = { once: true, margin: '-80px' };
export const viewportStrict = { once: true, margin: '-120px' };
